// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { openSnackbar } from './notify';
import { displayBackdrop, hideBackdrop } from './loading';

const API_URL = process.env.REACT_APP_API_URL;

// Define a service using a base URL and expected endpoints
export const contactService = createApi({
    reducerPath: 'contactService',
    baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
    tagTypes: ['CONTACT'],
    endpoints: (builder) => ({
        getContactList: builder.query({
            query: () => `contact`,
            providesTags: [{ type: 'CONTACT', id: 'all-contact' }],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(displayBackdrop());
                try {
                    const { data } = await queryFulfilled;
                    if(data){
                        dispatch(hideBackdrop());
                    }
                } catch (err) {
                    const { error } = err;
                    dispatch(hideBackdrop());
                    dispatch(openSnackbar({ options: { variant: "error" }, message: error?.data?.message || 'Something went wrong, Please try again.' }));
                }
            },
            transformResponse: (response) => response.data,
        }),
        createContact: builder.mutation({
            query: (initialPost) => ({ url: 'contact', method: 'POST', body: initialPost }),
            invalidatesTags: [{ type: 'CONTACT', id: 'all-contact' }],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                dispatch(displayBackdrop());
                try {
                    const { data } = await queryFulfilled;
                    if(data){
                        dispatch(hideBackdrop());
                    }
                } catch (err) {
                    const { error } = err;
                    dispatch(hideBackdrop());
                    dispatch(openSnackbar({ options: { variant: "error" }, message: error?.data?.message || 'Something went wrong, Please try again.' }));
                }
            },
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetContactListQuery, useCreateContactMutation } = contactService;